import { createContent } from '@altify/utils';

export const exploreProductsContent = createContent({
  en: {
    asset: 'Asset',
    lastPrice: 'Last Price',
    percentageChange: '% Change',
    deposit: 'Deposit',
    noResultsFound: 'No results found.',
    suggestNewAsset:
      'Request an asset to be listed by emailing our Client Success Team at',
    getNotified: 'Get Notified',
    launchNotificationSet: 'Notification Set',
    annualYield: 'Annual Yield',
    inviteAndEarnRewards: 'Invite & Earn Rewards',
    referYourFriends: 'Reward Your Friends & Earn',
    totalPortfolioValue: 'Total Portfolio Value',
    overTimePeriod: {
      '24h': 'over 24 hours',
      '7d': 'over 7 days',
      '1m': 'over 1 month',
      '3m': 'over 3 months',
      '1y': 'over 1 year',
      all: 'all-time return',
    },
    gotIt: 'Got It',
  },
  de: {
    asset: 'Asset',
    lastPrice: 'Last Price',
    percentageChange: '% Change',
    deposit: 'Deposit',
    noResultsFound: 'No results found.',
    suggestNewAsset: 'Suggest a new asset listing by emailing',
    getNotified: 'Get Notified',
    launchNotificationSet: 'Notification Set',
    annualYield: 'Annual Yield',
    inviteAndEarnRewards: 'Invite & Earn Rewards',
    referYourFriends: 'Reward Your Friends & Earn',
    totalPortfolioValue: 'Gesamtwert des Portfolios',
    overTimePeriod: {
      '24h': 'over 24 hours',
      '7d': 'over 7 days',
      '1m': 'over 1 month',
      '3m': 'over 3 months',
      '1y': 'over 1 year',
      all: 'all-time return',
    },
    gotIt: 'Got It',
  },
});
